import React, { useState } from 'react';
import styles from '../styles/CategoryModal.module.css'; 

const CategoryModal = ({ onClose, onSave }) => {
  const categories = [
    'Продукты питания',
    'Одежда и обувь',
    'Бытовая техника',
    'Электроника и гаджеты',
    'Косметика и уход',
    'Аптека и здоровье',
    'Товары для дома',
    'Автотовары и услуги',
    'Развлечения и досуг',
  ];

  const [selected, setSelected] = useState(categories[0]);

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3>Категории</h3>
          <button onClick={onClose} className={styles.closeBtn}>×</button>
        </div>
        <div className={styles.body}>
          {categories.map((category) => (
            <label key={category} className={styles.radioRow}>
                <input
                type="radio"
                value={category}
                checked={selected === category}
                onChange={() => setSelected(category)}
                />
                <span>{category}</span>
            </label>
          ))}
        </div>
        <div className={styles.footer}>
          <button onClick={onClose} className={styles.cancelBtn}>Отмена</button>
          <button
            onClick={() => {
              onSave(selected);
              onClose();
            }}
            className={styles.saveBtn}
          >
            Сохранить
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryModal;
